module.exports = {"TOTAL_COUNT":"%s1 TOTALE AANTAL","APPLY":"AANVRAAG","SELECT_ACTION":"SELECTEER ACTIE","FILTER_PRODUCTS":"FILTER PRODUCTEN"}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/staticTextMaps/datatable.json
// module id = 1573
// module chunks = 1